import React, { ErrorInfo, ReactNode } from "react";

/**
 * DataErrorBoundary catches runtime errors in its subtree.
 *
 * Per Section 7 (Error Handling) of the developer guide we expose a simple
 * `fallback` prop to render a UI when an error occurs.
 */
export class DataErrorBoundary extends React.Component<
  { fallback: ReactNode; children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { fallback: ReactNode; children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // In a real app we could log to an external monitoring service
    console.error("DataErrorBoundary caught an error", error, info);
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;
    return hasError ? <>{fallback}</> : <>{children}</>;
  }
}
